import Cookies from 'universal-cookie'

// STY-634: WordPress keys its session off the Auth0 access-token cookie.
// The theme's smp_auth0_cookie_login() clears the WP auth cookie the moment
// smp_access_token goes missing (it lives 24h), so once it lapses every
// wp-admin/admin-ajax.php call answers wp_die('0', 400) — the reply WordPress
// gives a logged-out user for an action with no nopriv handler. The app used
// to keep running on its legacy sessionStorage JWT and never notice.

export const ACCESS_TOKEN_COOKIE = 'smp_access_token'

// The token refresh route re-sets the cookie from the live Auth0 session and
// bounces back to returnTo; with no Auth0 session it sends the user to login.
export const REFRESH_PATH = '/api/auth/refresh'

// Do not bounce through the refresh route more than once a minute. If the
// cookie cannot be obtained (refresh loop, blocked cookie) the caller falls
// back to reporting the expired session instead of redirecting forever.
export const REFRESH_WINDOW_MS = 60 * 1000
const REFRESH_MARK = 'smp_wp_session_refresh_at'

const cookies = new Cookies()

export function hasAccessTokenCookie () {
  return Boolean(cookies.get(ACCESS_TOKEN_COOKIE))
}

// True for the admin-ajax "logged out" reply. axios JSON-parses the 1-byte
// body, so the '0' WordPress writes arrives as the number 0.
export function isWpSessionExpired (error) {
  const res = error && error.response
  if (!res || res.status !== 400) return false
  return res.data === 0 || res.data === '0'
}

const readMark = () => {
  try { return Number(sessionStorage.getItem(REFRESH_MARK)) || 0 } catch (e) { return 0 }
}
const writeMark = (now) => {
  try { sessionStorage.setItem(REFRESH_MARK, String(now)) } catch (e) { /* storage unavailable */ }
}

export function refreshReturnTo () {
  return window.location.pathname + window.location.search
}

// Sends the browser through the refresh route. Returns false, without
// navigating, when a refresh was already attempted inside REFRESH_WINDOW_MS —
// the cookie is not coming back and redirecting again would only loop.
export function refreshWpSession (returnTo = refreshReturnTo(), navigate = (url) => window.location.assign(url), now = Date.now()) {
  const last = readMark()
  if (last && now - last < REFRESH_WINDOW_MS) return false
  writeMark(now)
  navigate(`${REFRESH_PATH}?returnTo=${encodeURIComponent(returnTo)}`)
  return true
}

export const SESSION_EXPIRED_MESSAGE = 'Your WordPress session has expired. Sign out and sign back in, then try again.'
